import { HTTP_STATUS } from '../constants/kickavenue';

const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const isFiniteNumber = value => typeof value === 'number' && Number.isFinite(value);

const isValidPaginator = paginator => (
  isObject(paginator) &&
  Array.isArray(paginator.data) &&
  Number.isInteger(paginator.current_page) && paginator.current_page > 0 &&
  Number.isInteger(paginator.last_page) && paginator.last_page > 0 &&
  Number.isInteger(paginator.per_page) && paginator.per_page > 0 &&
  Number.isInteger(paginator.total) && paginator.total >= 0 &&
  (paginator.from === null || isFiniteNumber(paginator.from)) &&
  (paginator.to === null || isFiniteNumber(paginator.to))
);

export const normalizeCustomerReviewResponse = payload => {
  if (!isObject(payload) || payload.status_code !== HTTP_STATUS.OK) return null;

  const paginator = payload.data;
  if (!isValidPaginator(paginator)) return null;

  return {
    message: payload.message,
    status_code: payload.status_code,
    data: paginator.data,
    current_page: paginator.current_page,
    from: paginator.from,
    last_page: paginator.last_page,
    per_page: paginator.per_page,
    to: paginator.to,
    total: paginator.total,
    path: paginator.path,
    prev_page_url: paginator.prev_page_url,
    next_page_url: paginator.next_page_url
  };
};
